// extracted by mini-css-extract-plugin
export var overviewText = "OverviewText-module--overviewText--29aaV";